import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminOffers from "./pages/AdminOffers";
import AdminMenu from "./pages/AdminMenu";
import AdminReservations from "./pages/AdminReservations";
import AdminGallery from "./pages/AdminGallery";
import AdminAvailability from "./pages/AdminAvailability";
import AdminEvents from "./pages/AdminEvents";
import AdminSettings from "./pages/AdminSettings";
import AdminHours from "./pages/AdminHours";
import AdminTelegram from "./pages/AdminTelegram";
import "./App.css";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="offers" element={<AdminOffers />} />
            <Route path="menu" element={<AdminMenu />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="reservations" element={<AdminReservations />} />
            <Route path="availability" element={<AdminAvailability />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="hours" element={<AdminHours />} />
            <Route path="telegram" element={<AdminTelegram />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
